import { getFunctions, httpsCallable } from 'firebase/functions';
import type { VendorWorkType } from '../types';

export type QuoteRejectionRecipient = {
  supplierOrgId: string;
  quoteLabel: string;
  submissionId?: string;
};

export type SendSupplierQuoteRejectionEmailsInput = {
  dealId: string;
  dealTitle?: string;
  projectNumber?: string;
  projectName?: string;
  workType: VendorWorkType;
  rejectionReason: string;
  customEmailMessage?: string;
  senderName?: string;
  rfqProjectId?: string;
  recipients: QuoteRejectionRecipient[];
};

export type QuoteRejectionSendResult = {
  supplierOrgId: string;
  ok: boolean;
  sent: number;
  skipped?: boolean;
  reason?: string;
};

export type SendSupplierQuoteRejectionEmailsResult = {
  ok: boolean;
  results: QuoteRejectionSendResult[];
  totalSent: number;
};

export async function sendSupplierQuoteRejectionEmails(
  input: SendSupplierQuoteRejectionEmailsInput,
): Promise<SendSupplierQuoteRejectionEmailsResult> {
  const functions = getFunctions(undefined, 'us-central1');
  const fn = httpsCallable<
    SendSupplierQuoteRejectionEmailsInput,
    SendSupplierQuoteRejectionEmailsResult
  >(functions, 'sendSupplierQuoteRejectionEmails');
  const res = await fn(input);
  return res.data;
}
